document.addEventListener('turbo:frame-missing', (event) => {
  event.preventDefault();
  event.detail.visit(event.detail.response);
});
